import VcomProvider from '../../VcomProvider';
import AgGridThemeClass from './const/AgGridThemeClass';

export default function agGridThemeClass() {
  return VcomProvider.Layout.getTheme() === 'mcflat' ? AgGridThemeClass.LIGHT : AgGridThemeClass.DARK;
}
